import trackEvent from '../utils/trackEvent';

export default function cioIdentify(eventName, state) {
  const _eventData = { email: state.checkoutPageCustomerDetails.email.value };
  trackEvent(eventName, _eventData);
}
